import styled from "styled-components";

const Slider = styled.div`
  width: 100%;
  overflow-x: scroll;
  padding-bottom: 20px;
  ::-webkit-scrollbar {
    height: 4px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.2);
  }
`;

export default Slider;